import { createCRUDConstants } from "../../../utils/redux.utils";

export const nameSpace = "ISSUERDOMAINMAP";
export const issuerDomainMapConstants = createCRUDConstants(nameSpace);
